import React, { useState } from 'react';

import { Button } from '@leapfinance/frontend-commons';
import { type IButtonProps } from '@leapfinance/frontend-commons/components/geebee/Button';
import { GBTypography } from '@leapfinance/geebee-component-library';
import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import MuiDrawer, { type DrawerProps } from '@mui/material/Drawer';

type CustomDrawerProps = DrawerProps & {
  headerProps?: {
    title?: React.ReactNode;
    hideCrossButton?: boolean;
    classNames?: string;
  };
  renderHeader?: boolean;
};
interface IuseDrawerProps {
  disableBackdropClose?: boolean;
}
const useDrawer = (
  parentProps?: IuseDrawerProps,
): {
  DrawerButton: (props: IButtonProps) => JSX.Element;
  Drawer: (props: CustomDrawerProps) => JSX.Element;
  closeDrawer: () => void;
  openDrawer: () => void;
  isOpen: boolean;
} => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const DrawerButton = (props: IButtonProps) => (
    <Button {...props} onClick={() => setIsOpen(true)} />
  );

  const Drawer = (props: CustomDrawerProps) => {
    const { children, headerProps, renderHeader, ...rest } = props;
    return isOpen || rest.open ? (
      <MuiDrawer
        {...rest}
        key={rest.anchor}
        open={isOpen || rest.open}
        onClose={(event, reason) => {
          rest?.onClose?.(event, reason);
          if (parentProps?.disableBackdropClose && reason === `backdropClick`) {
            return;
          } else {
            setIsOpen(false);
          }
        }}
      >
        {renderHeader === true && (
          <div
            className={`flex items-center justify-between bg-primary-50 p-4 sticky top-0 z-100 ${
              headerProps?.classNames ?? ``
            }`}
          >
            {typeof headerProps?.title === `string` ? (
              <GBTypography variant="sh1Semibold" className="text-grey-900">
                {headerProps?.title}
              </GBTypography>
            ) : (
              headerProps?.title
            )}
            {!headerProps?.hideCrossButton && (
              <IconButton
                className="self-end"
                onClick={() => {
                  setIsOpen(false);
                  rest?.onClose?.({}, `escapeKeyDown`);
                }}
              >
                <Close />
              </IconButton>
            )}
          </div>
        )}
        {children}
      </MuiDrawer>
    ) : (
      <></>
    );
  };
  return {
    DrawerButton,
    Drawer,
    closeDrawer: () => setIsOpen(false),
    openDrawer: () => setIsOpen(true),
    isOpen,
  };
};

export default useDrawer;
